@if (!minimise) {

  <div class="modal-body">
    @if (showFormLoader) {
<div class="formLoader">
      <i class="fa fa-spinner fa-spin gt-refresh"></i>
    </div>
}

    @if (!showFormLoader && showReclassForm) {
<div class="reclass-form">
      <form ngNoForm novalidate autocomplete="off">
        @if (gridType === 'SYSTEM_BOOK_TO_TAX_SUMMARY' || rowData?.SYSTEM_ACCT) {
<div class="systemSummary">
          <div class="leftText nowrap">
            <strong>System Account</strong> - {{rowData.SYSTEM_ACCT}} - {{rowData.SYSTEM_ACCT_DESC}}<br>
            <strong>System Book Amt</strong> - {{rowData.BOOK_AMT | number:'1.0-0'}}<br>
            <strong>Other Adjs. Posted</strong> - {{rowData.BOOK_ADJ | number:'1.0-0'}}
          </div>
        </div>
}

        <div class="form-row">
          <div class="col-md-1"></div>
          <div class="col-md-4">
            <label>Book Adjustment Description:</label>
            <input type="text"
                   maxlength="250"
                   [(ngModel)]="RECLASS_DESCRIPTION"
                   (blur)="removeMessage()"
                   placeholder="Enter Book Adjustment Description"
                   class="form-control input-sm">
            @if (isSaveClicked && (!RECLASS_DESCRIPTION || RECLASS_DESCRIPTION.trim() === '')) {
<span class="form-error-container">
              Book Adjustment Description is required.
            </span>
}
            @if (isMaxLimitReached) {
<span class="form-error-container">
              You have reached the maximum limit of characters allowed
            </span>
}
          </div>

          @if (rowData.SOURCE_SYSTEM === 'DCS') {

            <div class="col-md-3">
              <label>Reclass Standard Description:</label>
              <select class="form-control input-sm" [(ngModel)]="modal.R_STD_DESC">
                <option value="">Select...</option>
                @for (desc of reclassDescDropdownData; track $index) {
<option [value]="desc">{{desc}}</option>
}
              </select>
            </div>
            <div class="col-md-4">
              <label>Comments:</label>
              <select class="form-control input-sm" [(ngModel)]="modal.R_CMT">
                <option value="">Select...</option>
                @for (cmt of commentsDescDropdownData; track $index) {
<option [value]="cmt">{{cmt}}</option>
}
              </select>
            </div>
          
}
        </div>

        <div class="accounts-header">
          <hr>
          <div class="header-row">
            <div class="col-action"></div>
            <div class="col-account">Account</div>
            <div class="col-tp">Trading Partner</div>
            <div class="col-book">Book Amt</div>
            <div class="col-prev">Other Adjs. Posted</div>
            <div class="col-cur">Current Adj Amt</div>
            <div class="col-total">Total</div>
          </div>
        </div>

        <div class="accounts-body">
          @for (account of accounts; track trackByIndex(i); let i = $index) {
<div class="account-row">
            <hr>
            <div class="row-content">
              <div class="col-action">
                @if (account.TYPE !== 'source') {
<i
                   (click)="removeAccount(i)"
                   class="fa fa-minus-circle color-red"
                   style="cursor: pointer;"
                   title="Remove This Account"></i>
}
              </div>

              <div class="col-account">
@switch (account.TYPE) {
                @case ('blank') {

                  @if (loadingSysAcct) {
<div class="gt-filter-loading">
                    <i style="color: #e12827; font-size: 24px;" class="fa fa-spinner fa-spin"></i>
                  </div>
}
                  @if (!loadingSysAcct) {
<select
                          class="form-control input-sm"
                          [(ngModel)]="account.selected"
                          (change)="setAccount(account.selected, i)">
                    <option [ngValue]="null" disabled>Select Account...</option>
                    @for (acc of limitedAccDropdownData; track $index) {
<option [ngValue]="acc">
                      {{acc.LOCAL_ACCT}} - {{acc.LOCAL_ACCT_DESC}}
                    </option>
}
                  </select>
}
                
}

                @default {

                  <span class="form-control input-sm readonly-field">{{account.LOCAL_ACCT}} - {{account.LOCAL_ACCT_DESC}}</span>
                
}
              }
</div>

              <div class="col-tp">
@switch (account.TYPE) {
                @case ('source') {

                  <span class="form-control input-sm readonly-field">{{account.TP_ENTITY}}</span>
                
}
                @case ('edit') {

                  <span class="form-control input-sm readonly-field">{{account.TP_ENTITY}}</span>
                
}
                @default {

                  <div class="autocomplete-wrapper">
                    <div class="input-group">
                      <input type="text"
                             class="form-control input-sm"
                             placeholder="begin typing to select trading partner"
                             [value]="account.tpSearchText || ''"
                             (input)="searchTradingPartners($event, i)">
                      <span class="input-group-addon">
                        @if (loadingTpSearch && activeTPSearchIndex === i) {
<i class="fa fa-spinner fa-pulse"></i>
}
                        @if (!loadingTpSearch || activeTPSearchIndex !== i) {
<i class="fa fa-search"></i>
}
                      </span>
                    </div>
                    @if (tpSearchResults.length > 0 && activeTPSearchIndex === i) {
<div class="autocomplete-dropdown">
                      @for (tp of tpSearchResults; track $index) {
<div class="autocomplete-item" (click)="selectTradingPartner(tp, i)">
                        {{tp.TP_ENTITY}}
                      </div>
}
                    </div>
}
                  </div>
                
}
              }
</div>

              <div class="col-book numText">
                @if (account.ISBOOKAMTLOADING) {

                  <i class="fa fa-spinner fa-pulse"></i>
                
} @else {
{{account.BOOK_AMT | number:'1.0-0'}}
}
                
              </div>

              <div class="col-prev numText">
                @if (account.ISBOOKADJLOADING) {

                  <i class="fa fa-spinner fa-pulse"></i>
                
} @else {
{{account.PREV_ADJ_AMT | number:'1.0-0'}}
}
                
              </div>

              <div class="col-cur">
                <div class="input-group">
                  <span class="input-group-addon">{{ rowData.FC }}</span>
                  <input type="number"
                         [(ngModel)]="account.CUR_ADJ_AMT"
                         (change)="setSourceTotal(i)"
                         [readonly]="account.TYPE === 'blank'"
                         class="form-control input-sm numText">
                </div>
              </div>

              <div class="col-total numText">
                {{account.TOTAL | number:'1.0-0'}}
              </div>
            </div>
          </div>
}
        </div>

        <hr>
        <div class="footer-row">
          <div class="col-action">
            <i (click)="addTargetAccount()"
               class="fa fa-plus-circle color-green"
               style="cursor: pointer;"
               title="Add new Account"></i>
          </div>
          <div class="col-spacer"></div>
          <div class="col-total-input">
            <div class="input-group">
              <span class="input-group-addon">{{ rowData.FC }}</span>
              <input type="text"
                     readonly
                     [ngClass]="{'color-background-red-light': reclassTotal !== 0}"
                     class="form-control input-sm"
                     [value]="reclassTotal">
            </div>
            @if (reclassTotal !== 0) {
<div class="form-error-container">*Book Adjustment must net to 0</div>
}
          </div>
          <div class="col-empty"></div>
        </div>
      </form>
    </div>
}
  </div>

  <div class="modal-footer">
    @if (!viewOnly) {
<button class="btn btn-info" type="button" [disabled]="isSaveClicked" (click)="save()">
      @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
    </button>
}
    @if (!viewOnly) {
<button class="btn btn-danger-outline" type="button" (click)="reset()">Reset</button>
}
    <button class="btn btn-warning" type="button" (click)="cancel()">Cancel</button>
  </div>

  @if (showReclassForm) {
<div class="existing-reclasses">
    <div class="table-responsive">
      <table class="gt-reclass-table table table-hover table-bordered table-striped table-condensed">
        <thead>
          <tr>
            <th></th>
            <th style="text-align: center;">Edit</th>
            <th style="text-align: center;">Delete</th>
            <th>Adjustment Description</th>
            <th>Adjustment Type</th>
            @if (rowData.SCENARIO_TYPE_CODE === 'EXAM') {
<th>Issue ID</th>
}
            @if (rowData.SCENARIO_TYPE_CODE === 'EXAM') {
<th>Scenario</th>
}
            <th>Last Updated</th>
            <th>Updated By</th>
          </tr>
        </thead>

        @if (existingLoading) {
<tbody>
          <tr>
            <td class="loading-table" colspan="9">
              <i style="margin-top:20px" class="fa fa-2x fa-spinner fa-pulse"></i>
            </td>
          </tr>
        </tbody>
}

        @if (noRecords && !existingLoading) {
<tbody>
          <tr>
            <td class="loading-table" colspan="9">
              <div style="margin-top:40px"><b>No Existing Book Adjustments</b></div>
            </td>
          </tr>
        </tbody>
}

        @if (!existingLoading) {
<tbody>
          @for (reclass of reclassArray; track $index; let i = $index) {

            <tr>
              <td align="center">
                <i (click)="showDetails(i, !reclass.open)" style="font-size:20px; cursor:pointer;" class="fa" [ngClass]="reclass.open ? 'fa-minus-circle' : 'fa-plus-circle'"></i>
              </td>
              <td align="center">
                @if (reclass.DISP_EDIT_LINK === 'Y') {
<span>
                  <a href="javascript:void(0)" (click)="loadReclass(i)">
                    @if (reclass.SHORT_ADJ_TYPE !== 'A') {
<i class="fa fa-pencil"></i>
}
                    {{reclass.SHORT_ADJ_TYPE !== 'A' ? 'Edit' : 'View'}}
                  </a>
                </span>
}
              </td>
              <td align="center">
                @if (reclass.DISP_EDIT_LINK === 'Y' && reclass.SHORT_ADJ_TYPE !== 'A') {
<span>
                  <a href="javascript:void(0)" (click)="deleteReclass(reclass)">
                    <i class="fa fa-times"></i>
                  </a>
                </span>
}
              </td>
              <td>{{reclass.ADJ_DESC}}</td>
              <td>{{reclass.ADJ_TYPE}}</td>
              @if (rowData.SCENARIO_TYPE_CODE === 'EXAM') {
<td>{{reclass.ISSUE_ID}}</td>
}
              @if (rowData.SCENARIO_TYPE_CODE === 'EXAM') {
<td>{{reclass.SCENARIO}}</td>
}
              <td>{{reclass.UPDATED_ON}}</td>
              <td>{{reclass.UPDATED_BY}}</td>
            </tr>
            @if (reclass.open) {
<tr>
              <td colspan="9" style="background-color:#cdcdcd">
                <table class="table table-hover table-bordered table-striped table-condensed-xs">
                  <thead>
                    <tr>
                      <th>Account</th>
                      <th>Counterparty</th>
                      <th>Account Desc</th>
                      <th>Amount Reclassified</th>
                    </tr>
                  </thead>
                  @if (!reclass.ACCOUNTS || reclass.ACCOUNTS.length === 0) {
<tbody>
                    <tr>
                      <td colspan="4" style="text-align:center;"><b>No Existing Book Adjustments</b></td>
                    </tr>
                  </tbody>
}
                  @if (reclass.ACCOUNTS && reclass.ACCOUNTS.length > 0) {
<tbody>
                    @for (acct of reclass.ACCOUNTS; track $index) {
<tr>
                      <td>{{acct.LOCAL_ACCT}}</td>
                      <td>{{acct.TP_ENTITY}}</td>
                      <td>{{acct.LOCAL_ACCT_DESC}}</td>
                      <td align="right" [ngClass]="{'color-red': acct.CUR_ADJ_AMT < 0}">
                        {{acct.CUR_ADJ_AMT | number:'1.0-0'}}
                      </td>
                    </tr>
}
                  </tbody>
}
                </table>
              </td>
            </tr>
}
          
}
        </tbody>
}
      </table>
    </div>
  </div>
}

}

